import React from "react"
import * as models from "../models/index"
import { DonutMathResponse } from "../models/donuts"
import DonutChart from "./DonutChart"
import AdditionIcon from "./DonutIcons/Addition"
import { toast } from "react-toastify"
import { RequestError } from "models/lib/modelRequest"

export default class AdditionDonut extends React.Component<{
  studentID?: string
  onLoaded?: (donutsResponse: DonutMathResponse) => void
  refresh?: boolean
}, {
  donutData: DonutMathResponse
  loading: boolean
}> {
  state = {
    loading: true,
    donutData: null
  }

  componentDidMount() {
    this.loadDonuts()
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.refresh && this.props.refresh) {
      this.loadDonuts()
    }
  }

  loadDonuts = () => {
    models.donuts.getMathProgress({
      studentID: this.props.studentID
    }).then((donutData) => {
      this.setState({ donutData }, () => {
        if (typeof this.props.onLoaded === 'function') {
          this.props.onLoaded(donutData)
        }
      })
    }).catch((error: RequestError) => {
      toast.error(error)
    }).finally(() => {
      this.setState({ loading: false })
    })
  }

  render() {

    if (this.state.loading) {
      return <></>
    }

    var { addition } = this.state?.donutData
    return (
      <div className="text-center">
        <DonutChart
          label="Addition"
          total={addition.total}
          completed={addition.completed}
          baseColor={"#DF554B"}
          Icon={AdditionIcon}
        />
      </div>
    )
  }
}
